module.exports = __webpack_public_path__ + "static/media/red_arrow_back_24px.b2c81bfc.svg";